import { getFormattedDateTimeByLocale, IDateTypeOptions } from '@treelab/panda';
import { Locale } from '../modules/core/types';

export const getFormattedArrayDateTime = (
  // i.e ["2019-08-25T00:00:00+08:00", "2019-08-25T00:00:00+08:00"]
  values: string[],
  typeOptions: IDateTypeOptions,
  locale: Locale,
) => {
  const adaptedValue =
    !!values && Array.isArray(values)
      ? values.map((dateTime: string) =>
          getFormattedDateTimeByLocale(dateTime, typeOptions, locale),
        )
      : [];

  return adaptedValue.join(', ');
};
